// extracted by mini-css-extract-plugin
export default {"lettersWrapper":"WordAnimator_lettersWrapper__k0x1a","letter":"WordAnimator_letter__40kcI"};